// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23CCf","top":"styles_top__1JDfd","left":"styles_left__3En7C","description":"styles_description__fGmVl"};